import { useEffect, useRef } from 'react';
import socketService from '../Utils/socket';
import useUserStore from '../Stores/UserStore';

export const useSocket = () => {
  const { token } = useUserStore();
  const isInitialized = useRef(false);

  useEffect(() => {
    if (token && !isInitialized.current) {
      socketService.connect(token);
      isInitialized.current = true;
    }

    return () => {
      // Don't disconnect on unmount, keep connection alive
      // socketService.disconnect();
    };
  }, [token]);

  return socketService;
};

export default useSocket;

